/** escape-html — XSS 이스케이프 (기능 함수 — 도메인 무관). `<b>` → `&lt;b&gt;` */
export const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
